export default "__VITE_ASSET__a8a4729e__"